import { useAppSettings, useAppSettingsInitialized } from "../app/hooks";
/**
 * Read-only view over the already-loaded application settings: it never issues
 * its own application-settings request. Loading and failure states come from
 * the app-settings initialization flow.
 */
export default function usePageSettingsStatus() {
    const settings = useAppSettings();
    const isSettingsInitialized = useAppSettingsInitialized();
    if (settings === null) {
        return isSettingsInitialized ? { status: "error" } : { status: "loading" };
    }
    // The id comes from the Backend's own settings response, so it is trusted as
    // an ApplicationIds even if the local enum lags behind; a genuinely unknown
    // id degrades through the content request as a 404 (empty row).
    return { status: "ready", settings, applicationId: settings.id };
}
